import {Component,
    OnInit,
    ViewChildren,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Inject,
	ViewRef,
	ElementRef,
	ViewChild
}
from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import moment from 'moment';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
// RXJS
import { BehaviorSubject, ReplaySubject } from 'rxjs';
//Service
import { DeNghiNhapKhoService } from '../kho-de-nghi-nhap-kho-page-service/kho-de-nghi-nhap-kho-page.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { LayoutUtilsService } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { DeNghiNhapKhoChiTiet, DeNghiNhapKho } from '../kho-de-nghi-nhap-kho-page-model/kho-de-nghi-nhap-kho-page.model';
import { DNNKLSNhapKhoDialogComponent } from '../kho-lich-su-nhap-list-dialog/kho-lich-su-nhap-list-dialog.component';

import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material';
import { NhapQuyTrinhDuyetService } from '../../../quy-trinh/nhap-quy-trinh-duyet/Services/nhap-quy-trinh-duyet.service';

@Component({
	selector: 'm-duyet-de-nghi-nhap-kho-page',
	templateUrl: './duyet-de-nghi-nhap-kho-page.component.html',
	styleUrls: ['../kho-de-nghi-nhap-kho-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class DuyetDeNghiNhapKhoComponent implements OnInit{


    /*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/


    /*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 6,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 7,
            name: 'Soluongchungtu',
            displayName: 'SL',
            alwaysChecked: false,
			isShow: true
		},
		// {
        //     stt: 7,
        //     name: 'SoLuongThucNhap',
        //     displayName: 'SL',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		{
            stt: 7,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoLuongThucNhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'SoXeSoMe',
            displayName: 'Số mẻ/số xe',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'MaThung',
            displayName: 'Số mẻ/số xe',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'PalletText',
            displayName: 'PalletText',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'XacThucPallet',
            displayName: 'Xác thực pallet',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'NgayDongThung',
            displayName: 'Ngày đóng thùng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'LenhSX',
            displayName: 'Lệnh SX',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'ExpiryDate',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'NgayNhanHang',
            displayName: 'Ngày nhận hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'Tag',
            displayName: 'Tags',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPOKH',
            displayName: 'Số PO KH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPONCC',
            displayName: 'Số PO NCC',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'NCC',
            displayName: 'NCC',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 11,
			name: 'OBJTHCP',
			displayName: 'Đối tượng THCP',
			alwaysChecked: false,
		},
		{
            stt: 10,
            name: 'Ghichulohang',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'TenNguoiKiemTra',
            displayName: 'Người duyệt',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'Ngaykiemtra',
            displayName: 'Ngày duyệt',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 13,
            name: 'Quyetdinhlohang',
            displayName: 'Kết quả',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'GhiChuKetQuaKiemTra',
            displayName: 'Lý do',
            alwaysChecked: false,
			isShow: true
		},
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
    ];
	sumColums: string[] = ['#','Soluongchungtu', 'SoLuongThucNhap'];

	/* ------------------------------------------------------------------*/


	/*--------------------Mat select search cho hàng hóa-----------------*/
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	sumRecord = 0;
	/* ------------------------------------------------------------------*/


   /*------------------------ Danh sách trạng thái ----------------------*/
	listState : any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */


    /*------------------------ Danh sách phòng ban -----------------------*/
	listPB : any[] = [];
	PBUser: string = '';
	selectPB : string = '';
	filteredPB: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	PBFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------------ Danh sách bộ phận ----------------------*/
	listBP : any[] = [];
	selectBP : string = '';
	filteredBP: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	BPFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*--------------------- Danh sách Khu vực sản xuất -------------------*/
	listKVSX : any[] = [];
	selectKVSX : string = '';
	filteredKVSX: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KVSXFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */

	// TREE
	public datatree: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ID_Struct: string = '';
	show_rooms = new BehaviorSubject<boolean>(false);

	/*------------------------ Danh sách loại phiếu ----------------------*/
	listLoaiPhieu : any[] = [];
	selectLoaiPhieu : string = '';
	filteredLoaiPhieu: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	LoaiPhieuFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


	/*------------------ Danh sách giai đoạn hàng hóa---------------------*/
	listGDHH : any[] = [];
	selectGDHH : string = '';
	filteredGDHH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	GDHHFilterCtrl: string = '';
	/* ------------------------------------------------------------------ */


    /* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiNhapKhoChiTiet>(true, []);
	/* ------------------------------------------------------------------ */


    /* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	loadingConfirm = new BehaviorSubject<boolean>(false);
	/* ------------------------------------------------------------------ */

	/* ------------------- Các form trên dialog --------------------------*/
	DNNKForm: FormGroup;				     //Form thông tin đề nghị nhập kho
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	DNNKItem: DeNghiNhapKho;
	listChiTietDNNK: DeNghiNhapKhoChiTiet[] = [];
	tmpChiTietDNNK: DeNghiNhapKhoChiTiet[] = [];
	originalChiTiet: DeNghiNhapKhoChiTiet[] = [];
	/* ------------------------------------------------------------------ */


    /*------------------------- Extend field: ----------------------------*/
	title: string = '';					// Tiêu đề dialog
	previousIndex: number; 				// Lưu lại vị trí trước đó khi swap các cột trên lưới
	fixedPoint = 2;                		// Số chữ số phần thập phân cho kiểu dữ liệu số.
	isChange: boolean = false;			// Trường kiểm tra dialog có cập nhập - thay đổi dữ liệu hay không
	isZoomSize: boolean = false;    	// Trường đánh dấu có đang ở trạng thái zoom size hay không
	saveAdded: number[] = []		    // Save ID các record đã thay đổi để đánh dấu highlight trên list khi đóng dialog
	viewLoading: boolean = false;   	// Loading khi mở dialog
    disableNewButton: boolean = true;	// Tắt nút thêm mới hàng khi chưa nhập đủ
	processImport: boolean = false;		// Có đang chạy import
	flagTab: number = 0;				// Định danh tab đang chạy
	optionsTinhTrang = [];
    /* ------------------------------------------------------------------ */

	// Tag Kho =====================================================================
	listTag: any[] = [];
	//==============================================================================

    constructor(
		private deNghiNhapKhoService: DeNghiNhapKhoService,
        private dungChungService: DungChungService,
        private DNNKFB: FormBuilder,
		public dialog: MatDialog,
		private router: Router,
		private subheaderService: SubheaderService,
		private activatedRoute: ActivatedRoute,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private treeService: NhapQuyTrinhDuyetService,

    ) {}

    /*---------------------------- LOAD DATA --------------------------------*/
    ngOnInit() {

		/*Load all dropdown and create form */
		this.getTree();
		this.ListId_HH();
		this.ListState();
		this.ListLoaiPhieu();
		this.ListPB();
		//this.ListBoPhan();
		this.ListGDHH();
		this.ListTagKho();

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.optionsTinhTrang = DeNghiNhapKho.optionsTinhTrang;
		this.DNNKItem = new DeNghiNhapKho();
		this.DNNKItem.clear();
		this.createForm();

		this.activatedRoute.params.subscribe(params => {
			const id = +params.id;

			if (id && id > 0) {
				this.DNNKItem.IdDn = id;
				this.deNghiNhapKhoService.getItemById(id).subscribe(res => {
					if(res.status == 1){
						this.DNNKItem = res.data
						if(res.data.Tinhtrang != DeNghiNhapKho.optionsTinhTrang[1].value
							&& res.data.Tinhtrang != DeNghiNhapKho.optionsTinhTrang[4].value){
							this.router.navigateByUrl('/404');
						}
						if(this.DNNKForm != null){
							if( ((this.DNNKItem.Tinhtrang == DeNghiNhapKho.optionsTinhTrang[1].value) && this.isCreate()) ||
							((this.DNNKItem.Tinhtrang == DeNghiNhapKho.optionsTinhTrang[1].value ||
							this.DNNKItem.Tinhtrang == DeNghiNhapKho.optionsTinhTrang[4].value) && this.haveApproveCase()) ){
								this.availableColumns.splice(0, 0, {
									stt: 0,
									name: 'select',
									displayName: 'Check chọn',
									alwaysChecked: true,
									isShow: true
								});
								this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
								/*Show column */
								this.showColumnsInTable();
								this.applySelectedColumns();
							}
							this.bindingValueAfterCallAPIDetail();
						}
					}
				});
			} else {
				this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[0].value;
				this.dungChungService.getBillNumber(DeNghiNhapKho.category_path).subscribe(res => {
					if (res.status == 1){
						this.DNNKItem.Sophieu = res.data;
						if(this.DNNKForm != null)
							this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
					}
				});
			}
		});

		this.title = this.getTitle();

		let breadcrumbs = [{ title: 'Kho' }, { title: 'Đề nghị nhập kho', page: '/de-nghi-nhap-kho'}, { title: 'Xử lý phiếu đề nghị nhập kho' }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);

		/*Show column */
		this.showColumnsInTable();
		this.applySelectedColumns();
    }
    /* -----------------------------------------------------------------------*/

    /*----------------- Create Form with appropriate sub forms ---------------*/
    createForm(){
		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
        this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.DNNKItem.Nguoitao = +idUser;

		/*Group các Form */
		this.DNNKForm = this.DNNKFB.group({
			SoPhieu: ['', Validators.required],
			NgayLapPhieu: [new Date(), Validators.required],
			TenNguoiLap: [tenNguoiLap],
			TrangThai: [this.nameState],
			LoaiPhieu: ['', Validators.required],
            PBDeNghi: [this.PBUser.toString(),Validators.required],
            NgayNhapKho: [new Date(), Validators.required],
			BPNhap: [''],
			PBNhap: [''],
			KhuVuc: [''],
			GiaiDoanHH: [''],
			Lydonhap: [''],
			LyDo: [''],
			ChungTuKemTheo: [false],
			SoChungTu: [''],
			MaKhachHang: [''],
			TenKhachHang: [''],
		});

		if(this.listState.length > 0){
			this.checkState();
		}

		/*Disable các trường dữ liệu không thay đổi */
        this.DNNKForm.disable();
		/*------------------------------------------------------------------*/

        this.changeDetectView();
	}
	isLoaiPhieuHTVTKH(){
		let value = +this.DNNKForm.controls["LoaiPhieu"].value;
		let item = this.listLoaiPhieu.find(x => x.Id == value)
		if(item != null)
			return item.Ma == DeNghiNhapKho.optionsLoaiPhieu[5].value;
		return false;
	}
	bindingValueAfterCallAPIDetail(){
		if(this.DNNKItem.IdDn > 0){
			/*Get name of người lập phiếu */
			var tenNguoiLap = '';
			this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

			var idUser = '';
			this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });

			this.DNNKForm.controls["SoPhieu"].setValue(this.DNNKItem.Sophieu);
			this.DNNKForm.controls["NgayLapPhieu"].setValue(this.DNNKItem.Ngaytao);
			this.DNNKForm.controls["TenNguoiLap"].setValue(this.DNNKItem.TenNguoitao);
			this.DNNKForm.controls["LoaiPhieu"].setValue(this.DNNKItem.LoaiPhieu.toString());
			this.DNNKForm.controls["NgayNhapKho"].setValue(this.DNNKItem.Ngaynhap);
			this.DNNKForm.controls["PBDeNghi"].setValue(this.DNNKItem.TenBoPhanDeNghi != null ? this.DNNKItem.TenBoPhanDeNghi.toString(): '');
			this.DNNKForm.controls["BPNhap"].setValue(this.DNNKItem.TenBoPhanNhap != null ? this.DNNKItem.TenBoPhanNhap.toString(): '');
			this.DNNKForm.controls["PBNhap"].setValue(this.DNNKItem.TenPhongBanNhap != null ? this.DNNKItem.TenPhongBanNhap.toString(): '');
			this.DNNKForm.controls["KhuVuc"].setValue(this.DNNKItem.KhuVucSanXuat_Id != null ? this.DNNKItem.KhuVucSanXuat_Id.toString(): '');
			this.DNNKForm.controls["GiaiDoanHH"].setValue(this.DNNKItem.QTSX_GiaiDoan_Id != null ? this.DNNKItem.QTSX_GiaiDoan_Id.toString(): '');
			this.DNNKForm.controls["Lydonhap"].setValue(this.DNNKItem.Lydonhap);
			this.DNNKForm.controls["LyDo"].setValue(this.DNNKItem.LyDo);
			this.DNNKForm.controls["SoChungTu"].setValue(this.DNNKItem.SoChungTu);
			this.DNNKForm.controls["ChungTuKemTheo"].setValue(this.DNNKItem.ChungTuKemTheo);
			this.DNNKForm.controls["MaKhachHang"].setValue(this.DNNKItem.MaKhachHang);
			this.DNNKForm.controls["TenKhachHang"].setValue(this.DNNKItem.TenKhachHang);
			this.checkState();
			//this.checkPB();

			/*Add dữ liệu chi tiết*/
			if(this.DNNKItem.listChiTietNhapKho.length > 0){
				this.listChiTietDNNK = this.DNNKItem.listChiTietNhapKho;
				this.tmpChiTietDNNK = [];
				this.originalChiTiet = [];

				for(let i = 0; i < this.listChiTietDNNK.length; i++){
					if(this.listChiTietDNNK[i].SoLuongThucNhap == null){
						this.listChiTietDNNK[i].SoLuongThucNhap = DeNghiNhapKho.DEFAULT_NUMBER_VALUE_NUMBER;
					}

					let tmpElement = new DeNghiNhapKhoChiTiet();
					tmpElement.copy(this.listChiTietDNNK[i]);

					if (tmpElement.Nguoikiemtra == 0) {
						tmpElement.Ngaykiemtra = moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
						tmpElement.Nguoikiemtra = +idUser;
						tmpElement.TenNguoiKiemTra = tenNguoiLap;
					}
					if(tmpElement.Quyetdinhlohang == -1){
						tmpElement.Quyetdinhlohang = 0
					}

					let tmpElementV2 = new DeNghiNhapKhoChiTiet();
					tmpElementV2.copy(tmpElement);

					this.tmpChiTietDNNK.push(tmpElement);
					this.originalChiTiet.push(tmpElementV2);
				}

				this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
			}
		}
	}
    getTitle(): string {
		return `Xử lý phiếu đề nghị nhập kho`;
	}
	haveApproveCase(){
		if(this.tmpChiTietDNNK.length > 0){
			return this.tmpChiTietDNNK.filter(x => x.IsVisible_Duyet == true && x.IsEnable_Duyet == true).length > 0;
		}
		else{
			return this.DNNKItem.listChiTietNhapKho.filter(x => x.IsVisible_Duyet == true && x.IsEnable_Duyet == true).length > 0;
		}
	}
    /* -----------------------------------------------------------------------*/
	getTotalNumber(){
		let total = 0;
		this.tmpChiTietDNNK.forEach(element => {
		   total += Number(element.SoLuongThucNhap)
		});
		return total;
	   }
	getTotalNumber2(){
		let total = 0;
		this.tmpChiTietDNNK.forEach(element => {
			total += Number(element.KhoiLuongQuyDoi)
		});
		return total;
		}


    /*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
    showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	getNumOfCanSelected(){
		var count = 0;
		this.tmpChiTietDNNK.forEach((x, index)=> {
			if(x.Quyetdinhlohang == 0 && x.KetQuaDuyet != 1 && this.listChiTietDNNK[index].Quyetdinhlohang >= 0){
				count++;
			}
		})
		return count;
	}
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.getNumOfCanSelected();
		return numSelected === numRows;
	}
	masterToggle() {
		;
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpChiTietDNNK.forEach((row, index) => {
				if(row.Quyetdinhlohang == 0 &&
				  row.KetQuaDuyet != 1 &&
				  this.listChiTietDNNK[index].Quyetdinhlohang >= 0){
					this.selection.select(row)
				}
			});
		}
	}

	//Bổ sung cho duyệt tất cả
	isAllSelectedDuyet() {
		const numSelected = this.selection.selected.length;
		const numRows = this.tmpChiTietDNNK.filter(x => x.IsVisible_Duyet == true && x.IsEnable_Duyet == true).length;
		return numSelected === numRows;
	}
	masterToggleDuyet() {
		if (this.isAllSelectedDuyet()) {
			this.selection.clear();
		} else {
			this.tmpChiTietDNNK.forEach(row => {
				if(row.IsVisible_Duyet && row.IsEnable_Duyet == true){
					this.selection.select(row)
				}
			});
		}
	}
    /* -----------------------------------------------------------------------*/

    /*------------------------- Hàm lấy danh sách-----------------------------*/
    ListState(){
		this.dungChungService.listState(DeNghiNhapKho.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.DNNKItem.Tinhtrang){
				this.nameState = element.Description;
				if(this.DNNKForm != null)
					this.DNNKForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}

    ListId_HH(){
		this.dungChungService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if(searchTmp != '' && searchTmp != null)
			search = '' + searchTmp;

		if (!search) {
			this.sumRecord = this.listId_HH.length;
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if(searchTmp != ''){
			this.sumRecord = this.listId_HH.filter(ts =>ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else{
			this.sumRecord = this.listId_HH.filter(ts => ts.MaHang.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.MaHang.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}

	ListPB(){
		this.dungChungService.listPhongBanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listPB = res.data;
				this.filteredPB.next(this.listPB.slice());

				var phongban = '';
				this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });

				if(this.DNNKItem.IdDn > 0){
					this.listPB.forEach(element => {
						if(element.Id_PB == +this.DNNKItem.BoPhanDeNghi){
							this.PBUser = element.Id_PB.toString();
						}
					})
				}
				else{
					this.listPB.forEach(element => {
						if(element.Id_PB == +phongban){
							this.PBUser = element.Id_PB.toString();
						}
					})
				}
				this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser.toString())
				this.changeDetectView();
			};
		});
	}
	filterPB() {
		if (!this.listPB) {
			return;
		}
		let search = this.PBFilterCtrl;
		if (!search) {
			this.filteredPB.next(this.listPB.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredPB.next(
			this.listPB.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	checkPB(){
		this.listPB.forEach(element => {
			if(element.Id_PB == this.DNNKItem.BoPhanDeNghi){
				this.PBUser = element.Id_PB.toString();
				if(this.DNNKForm != null)
					this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser.toString())
			}
		});
	}
	getTree(){
		this.treeService.Get_CoCauToChuc().subscribe(res => {
			if (res.data && res.data.length > 0) {
				this.datatree.next(res.data);
				var phongban = '';
				this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
				this.DNNKForm.controls["PBDeNghi"].setValue(this.PBUser.toString())
				//this.masterForm.controls['phongBan'].setValue(this.ID_Struct);
				this.changeDetectView();
			}
		});
	}
	ListBoPhan(){
		this.dungChungService.listBoPhanAll().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listBP = res.data;
				this.filteredBP.next(this.listBP.slice());
				this.changeDetectView();
			};
		});
	}
	filterBoPhan() {
		if (!this.listBP) {
			return;
		}
		let search = this.BPFilterCtrl;
		if (!search) {
			this.filteredBP.next(this.listBP.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredBP.next(
			this.listBP.filter(ts =>
				ts.TenPB.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	ListKVSXTheoBP(idBoPhan: any){
		this.dungChungService.listKhuVucSanXuatTheoBoPhan(idBoPhan).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKVSX = res.data;
				this.filteredKVSX.next(this.listKVSX.slice());
				this.changeDetectView();
			};
		});
	}
	filterKVSXTheoBP() {
		if (!this.listKVSX) {
			return;
		}
		let search = this.KVSXFilterCtrl;
		if (!search) {
			this.filteredKVSX.next(this.listKVSX.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKVSX.next(
			this.listKVSX.filter(ts =>
				ts.TenKhuVuc.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	ListGDHH(){
		this.dungChungService.listGiaiDoanHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listGDHH = res.data;
				this.filteredGDHH.next(this.listGDHH.slice());
				this.changeDetectView();
			};
		});
	}
	filterGDHH() {
		if (!this.listGDHH) {
			return;
		}
		let search = this.GDHHFilterCtrl;
		if (!search) {
			this.filteredGDHH.next(this.listGDHH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredGDHH.next(
			this.listGDHH.filter(ts =>
				ts.Ten.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}

	ListLoaiPhieu(){
		this.dungChungService.layDanhSachLoaiPhieu(DeNghiNhapKho.DEFAULT_LOAIPHIEU).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {

				this.listLoaiPhieu = res.data;
				this.filteredLoaiPhieu.next(this.listLoaiPhieu.slice());

				let item = this.listLoaiPhieu.find( x => x.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value)
				if(this.DNNKItem.IdDn > 0){
					item = this.listLoaiPhieu.find( x => x.Id == this.DNNKItem.LoaiPhieu)
				}

				if(item != null && this.DNNKForm != null){
					this.DNNKForm.controls["LoaiPhieu"].setValue(item.Id.toString())
				}

				this.changeDetectView();
			};
		});
	}
	filterLoaiPhieu() {
		if (!this.listLoaiPhieu) {
			return;
		}
		let search = this.LoaiPhieuFilterCtrl;
		if (!search) {
			this.filteredLoaiPhieu.next(this.listLoaiPhieu.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredLoaiPhieu.next(
			this.listLoaiPhieu.filter(ts =>
				ts.Ten.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	isNHSX(){
		let value = + this.DNNKForm.controls["LoaiPhieu"].value;
		let item = this.listLoaiPhieu.find(x => x.Id == value)
		if(item != null)
			return item.Ma == DeNghiNhapKho.optionsLoaiPhieu[0].value;
		return false;
	}
    /* -----------------------------------------------------------------------*/


    /*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string){
		let message = "";
		let controls = formGroup.controls;
		if(controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if(controls[columnName].hasError('maxlength')
			|| (controls[columnName].value.length > 22
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return DeNghiNhapKho.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER_DYNAMIC(item, FunctionPublic.MAX_POINT);
	}
	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9)
			{ return; }

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.formatComparenumber(data) < min && event.data && event.data == '0') data = this.f_currency_VND(this.formatNumber(min.toString()));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

			}else{
				controls[columnName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_currency_VND(this.formatNumber(tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_currency_VND(this.formatNumber(tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_currency_VND(this.formatNumber(min.toString())));
		}
	}
    /* -----------------------------------------------------------------------*/


    /*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
    getFormatDate(v: string = '') {
        if (v != null && v!= undefined && v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	minMaxDate(p_Val: any, item: any) {
		let d1 = new Date(p_Val);
		let d2 = new Date();

		if (d1.getTime() < d2.getTime()){
			this.tmpChiTietDNNK[this.tmpChiTietDNNK.indexOf(item)].Handung =  moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
		}
		this.changeDetectView();
	}
    /* -----------------------------------------------------------------------*/


	/*---------------------------- Thao tác trên form ------------------------*/
	async duyetAll(){
		const dialogRef = this.layoutUtilsService.POP02('');
		dialogRef.afterClosed().subscribe(async res => {
			if (!res) {
				return;
			}
			this.loadingConfirm.next(true);
			var selected = [];
			for(let i = 0; i < this.selection.selected.length; i++){
				let x =  this.selection.selected[i];
				let index = this.tmpChiTietDNNK.findIndex( element => element.IdCtdn == x.IdCtdn);
				if(index > - 1 && this.tmpChiTietDNNK[index].IsVisible_Duyet == true && this.tmpChiTietDNNK[index].IsEnable_Duyet == true){
					this.tmpChiTietDNNK[index].Nguoikiemtra = +this.tmpChiTietDNNK[index].Nguoikiemtra;
					this.tmpChiTietDNNK[index].Ngaykiemtra = moment(new Date(this.tmpChiTietDNNK[index].Ngaykiemtra)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
					this.tmpChiTietDNNK[index].Quyetdinhlohang = +this.tmpChiTietDNNK[index].Quyetdinhlohang;
					selected.push(this.tmpChiTietDNNK[index]);
				}
			}

			if (selected.length > 0){
				var resultCall = await this.deNghiNhapKhoService.duyetNhieuHang(selected).toPromise();
				if (resultCall.status == 1){
					this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[2].value
					for(let i = 0; i < this.selection.selected.length; i++){
						let x =  this.selection.selected[i];
						let index = this.tmpChiTietDNNK.findIndex( element => element.IdCtdn == x.IdCtdn);
            let indexConfirm = resultCall.data.findIndex( element => element.IdCtdn == x.IdCtdn);
						if(index > - 1 && indexConfirm > -1 && this.tmpChiTietDNNK[index].IsVisible_Duyet == true && this.tmpChiTietDNNK[index].IsEnable_Duyet == true){
							if(this.selection.isSelected(this.tmpChiTietDNNK[index])){
								this.selection.toggle(this.tmpChiTietDNNK[index]);
								i--;
							}

							this.tmpChiTietDNNK[index].isDone = resultCall.data[indexConfirm].isDone;
							this.tmpChiTietDNNK[index].IsEnable_Duyet = false;
							this.originalChiTiet[index].copy(this.tmpChiTietDNNK[index]);
							this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];

							let indexT = this.saveAdded.findIndex(x => x == this.DNNKItem.IdDn);
							if(indexT == -1)
								this.saveAdded.push(this.DNNKItem.IdDn);
							this.deNghiNhapKhoService.dataNew$.next(this.saveAdded)

							this.isChange = true;
							if(this.tmpChiTietDNNK[index].Quyetdinhlohang == 0){
								this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[1].value;
								this.listChiTietDNNK[index].Quyetdinhlohang = this.tmpChiTietDNNK[index].Quyetdinhlohang;
								if((this.DNNKItem.Tinhtrang == DeNghiNhapKho.optionsTinhTrang[1].value)
									&& this.isCreate()){

									let isExist = this.availableColumns.find(x => x.name == 'select');
									if(isExist == null){
										this.availableColumns.splice(0, 0, {
											stt: 0,
											name: 'select',
											displayName: 'Check chọn',
											alwaysChecked: true,
											isShow: true
										});
										this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
										/*Show column */
										this.showColumnsInTable();
										this.applySelectedColumns();
									}
								}
							}
						}
					}
					this.checkState();
					this.layoutUtilsService.showInfo("Quá trình duyệt phiếu hoàn tất");
				}
			}
			this.loadingConfirm.next(false);
			this.changeDetectView();
		})

	}
	duyetChiTiet(index: number){
		if (this.tmpChiTietDNNK[index].Quyetdinhlohang == 1 && (this.tmpChiTietDNNK[index].GhiChuKetQuaKiemTra == null || this.tmpChiTietDNNK[index].GhiChuKetQuaKiemTra == '')) {
			this.layoutUtilsService.showErorr('Vui lòng nhập lý do không duyệt');
			this.scrollToBottom();
			return;
		}

		const dialogRef = this.layoutUtilsService.POP02('');
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}

			this.tmpChiTietDNNK[index].Nguoikiemtra = +this.tmpChiTietDNNK[index].Nguoikiemtra;
			this.tmpChiTietDNNK[index].Ngaykiemtra = moment(new Date(this.tmpChiTietDNNK[index].Ngaykiemtra)).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietDNNK[index].Quyetdinhlohang = +this.tmpChiTietDNNK[index].Quyetdinhlohang;

			this.deNghiNhapKhoService.duyetTungHang(this.tmpChiTietDNNK[index]).subscribe(res => {
				if (res.status == 1) {
					const message='Duyệt hàng thành công';
					this.layoutUtilsService.showInfo(message);

					if(this.selection.isSelected(this.tmpChiTietDNNK[index])){
						this.selection.toggle(this.tmpChiTietDNNK[index]);
					}

					this.tmpChiTietDNNK[index].isDone = res.data.isDone;
					this.tmpChiTietDNNK[index].IsEnable_Duyet = false;
					this.originalChiTiet[index].copy(this.tmpChiTietDNNK[index]);
					this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];

					let indexT = this.saveAdded.findIndex(x => x == this.DNNKItem.IdDn);
					if(indexT == -1)
						this.saveAdded.push(this.DNNKItem.IdDn);
					this.deNghiNhapKhoService.dataNew$.next(this.saveAdded)

					this.isChange = true;
					this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[2].value
					if(this.tmpChiTietDNNK[index].Quyetdinhlohang == 0){
						this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[1].value;
						this.listChiTietDNNK[index].Quyetdinhlohang = this.tmpChiTietDNNK[index].Quyetdinhlohang;
						if((this.DNNKItem.Tinhtrang == DeNghiNhapKho.optionsTinhTrang[1].value)
							&& this.isCreate()){

							let isExist = this.availableColumns.find(x => x.name == 'select');
							if(isExist == null){
								this.availableColumns.splice(0, 0, {
									stt: 0,
									name: 'select',
									displayName: 'Check chọn',
									alwaysChecked: true,
									isShow: true
								});
								this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
								/*Show column */
								this.showColumnsInTable();
								this.applySelectedColumns();
							}
						}
					}
					this.checkState();

					this.changeDetectView();
				}
				else {
					if(res.data != null){
						this.tmpChiTietDNNK[index].DaLapPhieuNhapKho = res.data.DaLapPhieuNhapKho;
					}
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});
		});
	}
	isSelectedCoChungTu(){
		let form  = this.DNNKForm.controls;
		let value = form["ChungTuKemTheo"].value;
		return value ;
	}
	resetChiTiet(index: number){
		if(this.tmpChiTietDNNK. length > 0){
			this.tmpChiTietDNNK[index].copy(this.originalChiTiet[index]);
			this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
			this.changeDetectView();
		}
	}
	dongDeNghi(){
		;
		if (this.selection.selected.length <= 0) {
			this.layoutUtilsService.showErorr('Vui lòng chọn dữ liệu cần đóng đề nghị');
			return;
		}

		const dialogRef = this.layoutUtilsService.POP02('');
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}

			this.deNghiNhapKhoService.dongDeNghi(this.selection.selected).subscribe(res => {
				if (res.status == 1) {
					const message='Cập nhật thành công';
					this.layoutUtilsService.showInfo(message);

					this.selection.selected.forEach(row =>{
						row.KetQuaDuyet = 1;
					})
					this.selection.clear();
					this.tmpChiTietDNNK = [...this.tmpChiTietDNNK];
					this.isChange = true;
					this.DNNKItem.Tinhtrang = DeNghiNhapKho.optionsTinhTrang[6].value;
					this.checkState();
					this.changeDetectView();
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});
		});
	}
	isCreate(){
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		if(this.DNNKItem != null && (this.DNNKItem.Nguoitao == +idUser)){
			return true;
		}
		return false;
	}
	openHistoryDialog(item: DeNghiNhapKhoChiTiet){
		const dialogRef = this.dialog.open(DNNKLSNhapKhoDialogComponent, {
			data: {
				data: item.IdCtdn,
				MaHH: item.MaHH,
				TenHH: item.TenHH
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
		});
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------------ Extend Options --------------------------*/
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
    back(){
		window.history.back();
		//this.router.navigateByUrl('de-nghi-nhap-kho', { relativeTo: this.activatedRoute });
	}
	scrollToBottom(){
		setTimeout(() => {
			let height = document.getElementById('dialog-form').scrollHeight
			document.getElementById('dialog-form').scrollTo({ top: height, behavior: 'smooth' });
		}, 200);
	}
	/* -----------------------------------------------------------------------*/
	// .. Tag kho ========================================================================
	// .. Lấy danh sách tag kho
	ListTagKho() {
		this.dungChungService.listTagKho().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listTag = res.data;
				this.changeDetectView()
			};
		});
	}
	// .. Hàm lấy mã màu từ tên tag kho
	getBgColorTag(tag: string){
		var _item = this.listTag.find(_x => _x.tagkho == tag);
		return _item == null? '#ccc' : _item.BackgroundColor;
	}
	//================================================================================
}
